import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createButton: {
		id: 'native-issue-table.common.issue-create-form.create-button',
		defaultMessage: 'Create',
		description: 'Button text shown for the create issue button.',
	},
});
